import Vue from 'vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

Vue.component('pulse-loader', PulseLoader)
